import { produce } from 'immer';

import { State } from './types';
import { State as AllServicesState } from '../../TransferService/model';
import { PassengerId, SegmentId } from '../../../../types';
import { Dispatch } from 'react';
import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { initialStateFactory } from './initialStateFactory';

export const useMethods = (
	state: State,
	setState: Dispatch<State>,
	service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	parentState: AllServicesState['services']
) => {
	const onToggle = (passengerId: PassengerId, segmentId: SegmentId) => {
		setState(
			produce(state, draft => {
				draft[passengerId][segmentId].selected = !draft[passengerId][segmentId].selected;

				return draft;
			})
		);
	};

	const restoreState = () => setState(initialStateFactory(service, parentState));

	const removeTransfer = () => {
		setState(
			produce(state, (draft: State) => {
				Object.keys(draft).map(passengerId => {
					Object.keys(draft[passengerId]).map(segmentId => {
						if (draft[passengerId][segmentId] && !draft[passengerId][segmentId].confirmed) {
							draft[passengerId][segmentId].selected = false;
						}
					});
				});
			})
		);
	};

	return { onToggle, removeTransfer, restoreState };
};
